// extracted by mini-css-extract-plugin
export default {"pill":"v5GWg","pillDefaultStyle":"hwR3U"};